import layout from "../../assets/icons/layout.svg";
import bell from "../../assets/icons/bellBlackBold.svg";
import setting from "../../assets/icons/settings.svg";
import sliders from "../../assets/icons/sliders.svg";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { useTokenContext } from "../../context/tokenContext";
import { useNotifsStore } from "../../stores/Utils/notifs";
import Notifs from "../Cac/Partner/Utils/Notifs";
import { getNotifications } from "../../services/Api/userService";
import { useEffect } from "react";
import { changeFavicon } from "../../services/Utils/functionService";
import { useClickOutside } from "../../hooks/useClickOutside";
import { useSettingsStore } from "../../stores/Utils/settings";
import Settings from "../Cac/Partner/Utils/Settings";
import "../../css/sideBar.css";
import { readNotification } from "../../services/Api/notifService";
import help from "../../assets/icons/help-circle.svg";
import Help from "./Help";
import { showToastError } from "../../services/Toasts/toasts";

const SideBar = () => {
  const { roleId, isSuperAdmin } = useTokenContext();
  const { idPartner } = useParams();
  const { setShowSettings, showSettings } = useSettingsStore();
  const location = useLocation();
  const {
    notifs,
    setNotifs,
    showNotifs,
    setShowNotifs,
    unreadNotifCount,
    setUnreadNotifCount,
    showHelp,
    setShowHelp,
  } = useNotifsStore();

  const profil = location.pathname.includes("profil");

  useEffect(() => {
    const filterNotifDetails = notifs.filter(
      (el) => el.read === false || el.read === null
    );

    setUnreadNotifCount(filterNotifDetails.length);

    if (unreadNotifCount >= 1) {
      changeFavicon("/src/assets/logos/NexumX.png");
    } else {
      changeFavicon("/src/assets/logos/NexumX.png");
    }
  }, [notifs]);

  const toggleDetails = () => {
    getNotifications()
      .then((response) => {
        setNotifs(response);
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  useClickOutside([
    { elementId: "close-modal", callback: () => setShowNotifs(false) },
    { elementId: "close-modal-help", callback: () => setShowHelp(false) },
  ]);

  const handleReadNotif = (idCategory: number) => {
    readNotification(idCategory)
      .then(() => {
        getNotifications()
          .then(() => toggleDetails())
          .catch(() => showToastError("Une erreur s'est produite"));
        })
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 flex h-[calc(3.5rem+env(safe-area-inset-bottom))] w-full items-center justify-center border-t border-light-lavender bg-light-lavender pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_16px_rgba(15,23,42,0.12)] sm:bottom-0 sm:right-auto sm:top-0 sm:h-auto sm:w-14 sm:flex-col sm:justify-start sm:border-r sm:border-t-0 sm:pb-0 sm:shadow-xl">
      <ul className="flex w-full items-center justify-around px-3 font-K2D sm:mt-15 sm:flex-col sm:items-center sm:justify-start sm:px-0">
        <li className="list-none sm:mt-6">
          <NavLink
            to="/dashboard"
            className="flex justify-start items-center"
          >
            <img src={layout} alt="dashboard" className="w-6 h-6" />
          </NavLink>
        </li>
        {roleId === 3 && !profil && (
          <li className="hidden list-none lg:list-item">
            <NavLink
              to={`/partner/${idPartner}/admin/users/partner`}
              className="mt-10	hidden lg:flex justify-start items-center"
            >
              <img
                src={sliders}
                alt="ADMIN"
                className="hidden lg:flex w-6 h-6"
              />
            </NavLink>
          </li>
        )}
        <li className="list-none sm:mt-10" id="close-modal">
          <button
            className="relative flex justify-center items-center cursor-pointer "
            onClick={() => {
              setShowNotifs(!showNotifs);
              handleReadNotif(1);
            }}
          >
            <img src={bell} alt="notifications cloche" className="w-6 h-6 " />
            {unreadNotifCount > 0 && (
              <div className="flex justify-center items-center">
                <span className="absolute top-1 w-4 h-4 bg-red-500 rounded-full text-white text-xs flex items-center justify-center">
                  {unreadNotifCount}
                </span>
              </div>
            )}
          </button>
          <Notifs />
        </li>
        {isSuperAdmin === 1 ? (
          <li className="list-none sm:mt-10">
            <button
              className="relative flex justify-start items-center cursor-pointer"
              onClick={() => {
                setShowSettings(!showSettings);
              }}
            >
              <img src={setting} alt="parametre" className="w-6 h-6" />
            </button>
            <Settings />
          </li>
        ) : null}
        <li className="list-none sm:mt-10" id="close-modal-help">
          <button
            className="relative flex justify-start items-center"
            onClick={() => {
              setShowHelp(!showHelp);
            }}
          >
            <img src={help} alt="aide" className="w-6 h-6" />
          </button>
          <Help />
        </li>
      </ul>
    </nav>
  );
};

export default SideBar;
